import { render, staticRenderFns } from "./StoreTagEditor.vue?vue&type=template&id=5734f1a0&"
import script from "./StoreTagEditor.vue?vue&type=script&lang=js&"
export * from "./StoreTagEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports